import { Flex } from '@mantine/core';
import { useFlowByPhaseTabStore } from '../../../../../../store/strategy-store/strategy-store';
import { toggleFlowByPhasePhaseVisibility } from '../../../../../../store/strategy-store/strategy-store.actions';
import { LineChartLegendItemWithCheckbox } from '../../../components/line-chart/line-chart-legend-item-with-checkbox';
import { PHASES_METADATA } from '../../flow-by-phase-tab.constants';

export const FlowByPhaseChartLegend = () => {
  const visiblePhases = useFlowByPhaseTabStore((state) => state.visiblePhases);

  return (
    <Flex justify="center" align="center" gap="md" h="100%" wrap="wrap">
      {PHASES_METADATA.map((phase) => {
        return (
          <LineChartLegendItemWithCheckbox
            key={`legend-item-${phase.id}`}
            value={phase.id}
            label={phase.label}
            color={phase.color}
            isChecked={visiblePhases[phase.id]}
            onToggle={() => toggleFlowByPhasePhaseVisibility(phase.id)}
          />
        );
      })}
    </Flex>
  );
};
